import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export function Success() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const jobId = params.get("job");

  useEffect(() => {
    if (jobId) nav(`/jobs/${jobId}`, { replace: true });
  }, [jobId, nav]);

  return (
    <section className="mx-auto max-w-xl px-6 py-20 text-center">
      <h1 className="font-serif text-4xl tracking-tight">Payment received</h1>
      <p className="mt-3 text-neutral-600">Taking you to your video…</p>
    </section>
  );
}
